// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-2c7c02d0]{font-family:Roboto;font-size:20px;width:256px;height:52px;display:block;color:var(--gray-100);padding:11px 0 11px 0;margin:0 16px}.loader[data-v-2c7c02d0]{width:288px!important;height:40px!important;margin:20px 16px 0!important;padding:15px 70px 8px 66px!important;bottom:45px!important}.container[data-v-2c7c02d0]{margin-top:5px}", ""]);
// Exports
module.exports = exports;
